// src/import/ui/customPages/Hack4tts/Banner/HackHeaderTabs.js
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useLocation } from "react-router-dom";

const tabs = [
  // { key: "register",       label: "Registers" },
  { key: "about",       label: "About Us" },
  { key: "challenge",     label: "Challenge" },
  { key: "timeline",    label: "Timeline" },
  { key: "participation", label: "How to Participate" },
  { key: "evaluation",  label: "Evaluation" },
  { key: "resources",   label: "Resources" },
  { key: "faqs",        label: "FAQs" },
];

export default function HeaderTabs({
  registerHref = "/register",
  onTabChange = () => {},
  initialTab = "about",
  leftWidth = "20vw",   // ~20% screen
  minLeft = "280px"
}) {
  const [active, setActive] = useState(initialTab);
  const observerRef = useRef(null);
  const location = useLocation();

  const sectionIds = useMemo(() => tabs.map((t) => `#${t.key}`), []);

  const scrollToId = (hash) => {
    const el = document.querySelector(hash);
    if (!el) return;
    el.scrollIntoView({ behavior: "smooth", block: "start" });
    if (typeof window !== "undefined") {
      window.history.replaceState?.(null, "", hash);
    }
  };

  const handleNavClick = (e, hash) => {
    e.preventDefault();
    scrollToId(hash);
  };

  // Scrollspy
  useEffect(() => {
    const options = { root: null, rootMargin: "0px 0px -60% 0px", threshold: 0.2 };
    const obs = new IntersectionObserver((entries) => {
      const visible = entries
        .filter((en) => en.isIntersecting)
        .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
      if (visible?.target?.id) {
        setActive(visible.target.id);
        onTabChange(visible.target.id);
      }
    }, options);

    sectionIds.forEach((hash) => {
      const node = document.querySelector(hash);
      if (node) obs.observe(node);
    });

    observerRef.current = obs;
    return () => obs.disconnect();
  }, [sectionIds, onTabChange]);

  // Deep-link on load
  useEffect(() => {
    if (location.hash) {
      const t = setTimeout(() => scrollToId(location.hash), 100);
      return () => clearTimeout(t);
    }
  }, [location.hash]);

  return (
    <aside
      className="vh-sidebar"
      role="navigation"
      aria-label="Section Navigation"
      style={{ width: leftWidth, minWidth: minLeft }}
    >
      <div className="vh-brand">
        <h1 className="vh-title  h1-medium section-title title-navy-blue pb-2 ">Voice Tech for All</h1>
      </div>

      <ul className="vh-nav" role="tablist" aria-orientation="vertical">
        {tabs.map((t) => {
          const isActive = active === t.key || active === `#${t.key}`;
          return (
            <li key={t.key}>
              <a
                href={`#${t.key}`}
                role="tab"
                aria-selected={isActive}
                className={`vh-link ${isActive ? "is-active" : ""}`}
                onClick={(e) => handleNavClick(e, `#${t.key}`)}
              >
                <span className="vh-dot" aria-hidden />
                <span>{t.label}</span>
              </a>
            </li>
          );
        })}
      </ul>

      {/* <div className="vh-actions">
        <div className="registers-container">
          <a href="/register" className="register-btn-outline" target='_blank' rel='noreferrer '>
            Register Now
          </a>
        </div>
      </div> */}
    </aside>
  );
}
